export default __webpack_public_path__ + "static/media/hht2_ep11_speaking_04.df8282f5.png";